export const FORMULARIO_29_MODULE_ID = 'formulario_29'
export const CONSOLIDADO_F29_MODULE_ID = 'consolidado_f29'
export const TARJETAS_CREDITO_MODULE_ID = 'tarjetas_credito'
export const RENTA_MODULE_ID = 'renta'
export const ESTADO_DJ_MODULE_ID = 'estado_dj'
export const CUADRE_FORMULARIO_29_MODULE_ID = 'cuadre_formulario_29'

/**
 * En el modal de USUARIO (cuando hay `roles`): sin fila → ON para ADMIN/COLABORADOR/
 * SUPER_COLABORADOR y OFF para USER_SMARTCFO.
 * En el modal de EMPRESA no se usa (roles es undefined) y aplica explicitGrant.
 */
export const STAFF_DEFAULT_MODULE_IDS = [
  FORMULARIO_29_MODULE_ID,
  CONSOLIDADO_F29_MODULE_ID,
  TARJETAS_CREDITO_MODULE_ID,
  RENTA_MODULE_ID,
  ESTADO_DJ_MODULE_ID,
  CUADRE_FORMULARIO_29_MODULE_ID,
]

export { defaultConfiguracionEquipoAccess as defaultStaffModuleAccess } from './configuracionEquipoModule'
